import { render, staticRenderFns } from "./MoreItems.ts.vue?vue&type=template&id=a506e3de"
import script from "./MoreItems.ts.vue?vue&type=script&setup=true&lang=ts"
export * from "./MoreItems.ts.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./MoreItems.ts.vue?vue&type=style&index=0&id=a506e3de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports